let globalDialogHandler = null;

export const registerDialogHandler = (handlerFn) => {
	globalDialogHandler = handlerFn;
};

/**
 * Shows a global error dialog.
 * 
 * @param {string} title - Title of the error dialog.
 * @param {string} message - Error message to display.
 * @param {object} options - Optional settings.
 * @param {boolean} options.redirectToLogin - Whether to redirect to login after countdown.
 * @param {number} options.countdownSeconds - Countdown duration in seconds before redirect.
 */
export const showGlobalDialogError = (
	title = 'Something Went Wrong',
	message = 'Please check your connection and try again. If the issue persists, try refreshing the page.',
	options = {}
) => {
	const { redirectToLogin = false, countdownSeconds = 10 } = options;

	if (typeof globalDialogHandler === 'function') {
		if (!redirectToLogin) {
			// Normal error, no redirect
			globalDialogHandler(title, message);
			return;
		}

		// Redirect flow
		let secondsLeft = countdownSeconds;

		const interval = setInterval(() => {
			secondsLeft--;

			if (secondsLeft > 0) {
				globalDialogHandler(
					title,
					`Your session has expired. Redirecting to the login page in <strong>${secondsLeft}</strong> seconds...`,
					redirectToLogin
				);
			} else {
				clearInterval(interval);
				localStorage.clear();
				window.location.href = '/login';
			}
		}, 1100);
	} else {
		console.warn('Dialog handler not registered:', message);
	}
};
